import type { ForgetPasswordOTPRequest, IErrorResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useForgetPasswordOtp = (): UseMutationResult<
  [],
  IErrorResponse,
  ForgetPasswordOTPRequest
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.forgetPasswordOtp, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('sendToCode'),
      });
    },
  });
};

export default useForgetPasswordOtp;
